<template>
  <ExpedienteEntryDescargo :entry="entry"></ExpedienteEntryDescargo>
</template>

<script>
import ExpedienteEntryDescargo from './ExpedienteEntryDescargo'

export default {
  props: {
    entry: Object
  },

  components: {
    ExpedienteEntryDescargo
  }
}
</script>
